import { Container, ContainerPadding, Text, TokenTextAppearance } from '@volkswagen-onehub/components-core';
import { default as React } from 'react';
import { FIELD_NAME } from '../../constants/form-constants';
import { Section } from '../screen/section';
import { CtasRadio } from './inputs/core/ctas-radio';

interface Props {
	showPerfilado?: boolean;
	showComunicacionesComerciales?: boolean;
	paddingTop?: ContainerPadding;
	paddingBottom?: ContainerPadding;
}

export function ConsentimientosSection(props: Props) {
	const { paddingTop, paddingBottom, showPerfilado, showComunicacionesComerciales } = props;
	const options = [
		{
			value: 'PERMITE',
			text: 'Aceptar',
			selectedText: 'Aceptado',
			emphasis: 'primary' as const,
		},
		{ value: 'NO INFORMADO', text: 'Omitir' },
	];

	return (
		<Container stretchContent padding={{ top: paddingTop || undefined, bottom: paddingBottom || undefined }}>
			<div>
				{showPerfilado && showComunicacionesComerciales && (
					<Section>
						<Text bold appearance={TokenTextAppearance.headline200}>
							¿Seguimos en contacto?
						</Text>
					</Section>
				)}
				{showComunicacionesComerciales && (
					<Section paddingTop={ContainerPadding.static300}>
						<Text appearance={TokenTextAppearance.copy200}>
							¿Te gustaría recibir descuentos y novedades de Volkswagen?
						</Text>

						<CtasRadio
							name={FIELD_NAME.RGPD_COMUNICACIONES_COMERCIALES}
							options={options}
							size="large"
							required
							enableOnClick
						/>
					</Section>
				)}
				{showPerfilado && (
					<Section paddingTop={ContainerPadding.static300}>
						<Text appearance={TokenTextAppearance.copy200}>
							¿Te gustaría que elaboremos un perfil tuyo para ofrecerte información comercial sobre productos y
							servicios de nuestras marcas que creamos que te puedan interesar más según tus preferencias?
						</Text>
						<CtasRadio name={FIELD_NAME.RGPD_PERFILADO} options={options} size="large" required enableOnClick />
					</Section>
				)}
			</div>
		</Container>
	);
}
